<template lang="pug">
.footer(ref="footer")
  footer
    div.info
      | Copyright 2025, MelodyStep Limited. All Rights Reserved.
    .info
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>

<style lang="stylus" scoped="">
.footer
  margin-top: .48rem
  footer
    text-align: center
    font-size: 0.24rem
    .nav
      margin-bottom: .1rem
      .link
        display: inline-block
        color: #606266
        padding: 0 0.1rem
      .link:last-child
        border: 0
      .ins
        border-right: solid 1px $grey
        margin: auto .06rem
    .info
      color: #b3b3b3
    .bannerLink
      display: block
      overflow: hidden
      height: 1.3rem
      .banner
        z-index: 999
        height: 1.3rem
        width: 100%
  .info + .info
    margin-top: 0.1rem
</style>
